export default defineNuxtPlugin({
  parallel: true,
  setup() {
    const analytics = useGoogleAnalytics();
    analytics.setUserId();
  },
});
